import React from 'react';
import { SvgIcon } from '@mui/material';

const ClockIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
      fill="currentColor"
    />
    <path
      d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default ClockIcon;
